'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Timeline = require('./Timeline');

var _Timeline2 = _interopRequireDefault(_Timeline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _Timeline2['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/timeline/index.js
// module id = 1517
// module chunks = 0